<template>
  <div class="width-100 min-height flex-column align-items-center justify-content-start bg-image" style="padding: 0 3%">
    <div
      class="width-100 bg-image2 flex-column align-items-center justify-content-start br-reg position-relative"
      style="margin-top: 80px; padding: 10% 5%"
    >
      <div class="bg-22"></div>
      <div class="fm-sh-bold fs-mid width-100">收货信息</div>
      <van-field v-model="name" placeholder="请输入姓名" class="width-100" style="padding: 0.625rem 0; border-bottom: 1px solid #eee" />
      <van-field
        v-model="phoneNumber"
        type="number"
        placeholder="请输入手机号"
        class="width-100"
        style="padding: 0.625rem 0; border-bottom: 1px solid #eee"
      />
      <van-field
        is-link
        v-model="place"
        readonly
        placeholder="请选择所在地区"
        @click="show = true"
        style="padding: 0.625rem 0; border-bottom: 1px solid #eee"
      />
      <van-field v-model="xiangxiPlace" placeholder="请输入详细地址" class="width-100" style="padding: 0.625rem 0; border-bottom: 1px solid #eee" />
    </div>
    <div class="width-100 border br-reg margin-t" style="padding: 5%">
      <div class="fm-sh-bold fs-mid width-100">商品信息</div>
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-ts">
        <div style="width: 5rem; height: 5rem" class="border flex-row align-items-center justify-content-center br-reg">
          <van-image :src="$route.query.picture_url" width="80%" height="80%" fit="contain" />
        </div>
        <div class="width-70 flex-column align-items-center justify-content-start" style="height: 5rem">
          <div class="fs-mid fm-sh-regular width-100 textAlign-l">{{ $route.query.name }}</div>
          <div class="fs-mid-sml grey-999 fm-sh-regular width-100 textAlign-l">{{ $route.query.zjnum }}</div>
          <div class="fs-mid-sml grey-999 fm-sh-regular width-100 textAlign-l">{{ $route.query.cre_time }}</div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-cascader title="请选择所在地区" :options="placeList" @close="show = false" @finish="onFinish" />
    </van-popup>
    <div
      class="white fs-big width-50 textAlign-c br-reg fm-sh-regular margin-t"
      style="background: #0053f0; height: 2rem; line-height: 2rem"
      @click="submitDiv"
    >
      确认
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getPcd, fill_address } from '../api/zhishu';
export default {
  data() {
    return {
      show: false,
      name: '',
      phoneNumber: '',
      place: '',
      xiangxiPlace: '',
      placeList: [],
      placeId1: '',
      placeId2: '',
      placeId3: ''
    };
  },
  beforeMount() {
    getPcd().then((res) => {
      this.placeList = res.data;
    });
  },
  watch: {
    '$route.path': {
      deep: true,
      handler(v, o) {
        if (o == '/writePlace') {
          this.$destroy();
        }
      }
    }
  },
  methods: {
    onFinish(key) {
      let value = '';
      key.selectedOptions.forEach((item) => {
        value += item.text;
      });
      console.log(key);
      this.placeId1 = key.selectedOptions[0].id;
      this.placeId2 = key.selectedOptions[1].id;
      this.placeId3 = key.selectedOptions[2].id;
      this.place = value;
      this.show = false;
    },
    submitDiv() {
      if (this.name == '') {
        Toast('姓名不能为空');
        return;
      } else if (this.phoneNumber == '') {
        Toast('手机号不能为空');
        return;
      } else if (this.placeId1 == '') {
        Toast('地址不能为空');
        return;
      } else if (this.placeId2 == '') {
        Toast('地址不能为空');
        return;
      } else if (this.placeId3 == '') {
        Toast('地址不能为空');
        return;
      }
      fill_address({
        id: this.$route.query.id,
        consignee: this.name,
        consignee_phone: this.phoneNumber,
        province_id: this.placeId1,
        city_id: this.placeId2,
        district_id: this.placeId3,
        address: this.xiangxiPlace
      })
        .then((res) => {
          if (res.code == 0) {
            Toast(res.msg);
            this.$router.back();
          } else {
            Toast(res.msg);
          }
        })
        .catch((err) => console.log(err));
    }
  }
};
</script>

<style scoped>
.bg-image {
  background-image: url('../assets/image/luckyDrawDetails/bg33.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.bg-image2 {
  background-image: url('../assets/image/luckyDrawDetails/bg11.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.bg-22 {
  width: 5rem;
  height: 5rem;
  background-image: url('../assets/image/luckyDrawDetails/bg22.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  top: -10%;
  right: 10%;
}
::v-deep .van-cell::after {
  display: none;
}
</style>
